<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png">
<!--    <HelloWorld msg="Welcome to Your Vue.js App"/>-->
  </div>
</template>

<script>
  const wx = require('weixin-js-sdk')
  // @ is an alias to /src
  import axios from 'axios'
  import HelloWorld from '@/components/HelloWorld.vue'
  import store from '@/store'

  export default {
    name: 'home',
    components: {
      HelloWorld
    },
    mounted() {
      this.$nextTick(() => {
        console.log('begin!!')
        let code = this.$route.query.code
        let state = this.$route.query.state
        console.log(store)
        store.dispatch('AccountServ_LoginByWechatServiceAccount', {
          params: {wechatCode: code},
          urlparams: null
        }).then((res) => {
console.log(res)
        }).catch(err => {
console.log(err)

        })
      })

    },
    methods: {
    }
  }
</script>
